var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSelfie = function SvgSelfie(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.188 11.563H7.813a1.875 1.875 0 0 0-1.875 1.874v16.876a1.875 1.875 0 0 0 1.875 1.875h24.375a1.875 1.875 0 0 0 1.874-1.876V13.438a1.875 1.875 0 0 0-1.874-1.874h-9.376",
    stroke: "#F39237",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.813 10.625a2.812 2.812 0 1 0-5.625 0v3.75a.938.938 0 0 0 .937.938h3.75a.938.938 0 0 0 .938-.938v-3.75ZM15.313 25.625a3.281 3.281 0 1 0 0-6.563 3.281 3.281 0 0 0 0 6.563ZM9.688 32.188a5.625 5.625 0 1 1 11.25 0H9.688ZM22.813 20.938h5.625M22.813 24.688h7.5",
    stroke: "#F39237",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgSelfie;